import { render, staticRenderFns } from "./AudioControls.vue?vue&type=template&id=2b640481&scoped=true"
import script from "./AudioControls.vue?vue&type=script&lang=js"
export * from "./AudioControls.vue?vue&type=script&lang=js"
import style0 from "./AudioControls.vue?vue&type=style&index=0&id=2b640481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b640481",
  null
  
)

export default component.exports